export default "__VITE_ASSET__u1nLkFl4__"